import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Slick from "react-slick";

import { PrimaryOutline } from "../../components/Buttons/Buttons";
import home from "./home.scss";
import styles from "./styles/home-team.scss";
import ReactDOM from "react-dom";
import ErrorBoundary from "../../Utilities/ErrorBoundary";
const production = process.env.NODE_ENV === "production";

const TeamSlide = props => {
  const { uri, focused_img, title, slug } = props;
  const imgData = JSON.parse(focused_img);
  const {config, id} = imgData;
  return (
    <a className={styles.link} href={`/${uri}/slug/${slug}`}>
      <figure>
        <img src={`/image/${id}/400`} alt="" style={{objectPosition: config['background-position']}} />
        <figcaption className={styles.title}>{title}</figcaption>
      </figure>
    </a>
  );
};
TeamSlide.propTypes = {
  uri: PropTypes.string.isRequired,
  focused_img: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
const NextArrow = props => {
  const { className, onClick } = props;

  return (
    <button
      type="button"
      className={`${styles.nextButton} ${className}`}
      onClick={onClick}
    >
      <i className="fa fa-chevron-right" />
    </button>
  );
};

const PrevArrow = props => {
  const { className, onClick } = props;

  return (
    <button
      type="button"
      className={`${styles.prevButton} ${className}`}
      onClick={onClick}
    >
      <i className="fa fa-chevron-left" />
    </button>
  );
};

class Team extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      slider: null
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  componentDidMount() {}

  next() {
    this.slider.slickPause();
    this.slider.slickNext();
  }

  previous() {
    this.slider.slickPause();
    this.slider.slickPrev();
  }

  render() {
    const { settings, heading, strings, staffBlock } = this.props;

    const parsedSettings = {
      speed:
        settings && settings["Slideshow Speed"]
          ? +settings["Slideshow Speed"]
          : 1000,
      autoplaySpeed:
        settings && settings["Slideshow Delay"]
          ? +settings["Slideshow Delay"]
          : 5000
    };

    const sliderSettings = {
      dots: false,
      infinite: true,
      speed: 500,
      lazyLoad: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerPadding: 0,
      center: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 576,
          settings: {
            swipeToSlide: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    const { Button, Caption } = strings;
    const parsedButton = Button ? Button : {};
    return (
      <ErrorBoundary>
        <div className={styles.wrapper}>
          <div className={styles.container}>
            <h2 className={home.heading}>{heading}</h2>
            <p className={styles.description}>{Caption}</p>
            <div className={styles.slider} data-count={staffBlock.data.length}>
              <PrevArrow onClick={this.previous} />
              <Slick
                {...sliderSettings}
                ref={slider => (this.slider = slider)}
                className={styles.teamSlider}
              >
                {staffBlock.data.map((member, index) => (
                  <TeamSlide
                    key={member.id}
                    {...member}
                    uri={staffBlock.page.uri}
                  />
                ))}
              </Slick>
              <NextArrow onClick={this.next} />
            </div>

            <PrimaryOutline
              link={parsedButton.url}
              text={parsedButton.text}
              cls={styles.button}
            />
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}
export default Team;

Team.propTypes = {
  staffBlock: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  strings: PropTypes.object.isRequired
};

if (PRODUCTION && document) {
  const dataJSON = JSON.parse(
    document.getElementById("homeTeamData").innerHTML
  );
  const config = {
    ...dataJSON
  };

  ReactDOM.render(<Team {...config} />, document.getElementById("homeTeam"));
}
